import { sortLegsByDate } from 'utils/sortLegsByDate';

export const findEarliest = (legs) => {
  if (legs && legs.length <= 0) {
    return null;
  }

  const [{ timing }] = [...legs].sort(sortLegsByDate);

  return timing.date;
};
